/* Free-gift cart guard — Roofus.
   Mystery Gift / Free Paw Cleanser are $0 products used ONLY inside the funnels.
   Blocks the exploit of checking out a gift on its own: any cart containing ONLY
   $0 gift lines (no paid item) is auto-emptied and its checkout blocked. A cart
   with a paid item + gift (the funnel's normal state) is never touched. */
(function () {
  var GIFT_PRODUCT_IDS = [7860229701709, 7860229767245, 7814542524493];
  function isGiftItem(i){ return i.price === 0 || GIFT_PRODUCT_IDS.indexOf(i.product_id) !== -1; }
  function giftOnly(cart){ return cart && cart.items && cart.items.length > 0 && cart.items.every(isGiftItem); }
  var blocked = false;
  function getCart(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}, credentials:'same-origin'}).then(function(r){return r.json();}); }
  function clearCart(){ return fetch('/cart/clear.js', {method:'POST', headers:{'Content-Type':'application/json'}, credentials:'same-origin'}); }
  function enforce(){
    return getCart().then(function(cart){
      blocked = giftOnly(cart);
      if (blocked){
        return clearCart().then(function(){
          blocked = false;
          if (location.pathname.indexOf('/cart') === 0) location.reload();
          else document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
      }
    }).catch(function(){});
  }
  if (document.readyState !== 'loading') enforce();
  else document.addEventListener('DOMContentLoaded', enforce);
  if (window.fetch){
    var _f = window.fetch;
    window.fetch = function(){
      var a = arguments, u = (a[0] && a[0].url) || a[0] || '';
      return _f.apply(this, a).then(function(res){
        if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) setTimeout(enforce, 80);
        return res;
      });
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){
    try { if (typeof u === 'string' && /\/cart\/(add|change|update)/.test(u)) this.addEventListener('load', function(){ setTimeout(enforce, 80); }); } catch(e){}
    return _open.apply(this, arguments);
  };
  document.addEventListener('click', function(e){
    var t = e.target, el = t && t.closest ? t.closest('[name="checkout"], button[name="checkout"], a[href*="/checkout"], .cart__checkout, .cart-checkout, [data-checkout]') : null;
    if (!el) return;
    if (blocked){ e.preventDefault(); e.stopImmediatePropagation(); enforce(); }
  }, true);
})();
